import { API_BASE } from '@/config/api'

async function request (path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }
  })
  const result = await response.json()
  if (!response.ok || result.code !== 0) {
    const error = new Error(result.msg || '请求失败')
    error.code = result.code
    throw error
  }
  return result.data
}

export const listDepartments = () => request('/api/manager/departments')
export const createDepartment = (payload) => request('/api/manager/departments', {
  method: 'POST', body: JSON.stringify(payload)
})
export const updateDepartment = (id, payload) => request(`/api/manager/departments/${id}`, {
  method: 'PUT', body: JSON.stringify(payload)
})

export const listSlots = (params = {}) => {
  const query = new URLSearchParams()
  Object.keys(params).forEach(key => { if (params[key]) query.set(key, params[key]) })
  return request(`/api/manager/appointment-slots${query.toString() ? `?${query}` : ''}`)
}
export const listSlotDatePage = (params = {}) => {
  const query = new URLSearchParams({ page: String(params.page || 0) })
  ;['departmentId', 'appointmentDate', 'keyword'].forEach(key => { if (params[key]) query.set(key, params[key]) })
  return request(`/api/manager/appointment-slots/page?${query}`)
}
export const createSlot = (payload) => request('/api/manager/appointment-slots', {
  method: 'POST', body: JSON.stringify(payload)
})
export const createSlots = (payload) => request('/api/manager/appointment-slots/batch', {
  method: 'POST', body: JSON.stringify(payload)
})
export const updateSlot = (id, payload) => request(`/api/manager/appointment-slots/${id}`, {
  method: 'PUT', body: JSON.stringify(payload)
})

export const listAppointments = (params = {}) => {
  const query = new URLSearchParams({ keyword: params.keyword || '', page: String(params.page || 0), size: String(params.size || 20) })
  ;['startDate', 'endDate'].forEach(key => { if (params[key]) query.set(key, params[key]) })
  return request(`/api/manager/appointments?${query}`)
}
export const cancelAppointment = (id) => request(`/api/manager/appointments/${id}/cancel`, { method: 'POST' })
